module.exports = __webpack_public_path__ + "static/media/prazo2.67920536.png";